<ssg-checkbox-list
  *ngIf="form"
  [name]="key"
  [apiName]="apiName"
  [systemName]="systemName"
  [category]="category"
  [textFieldName]="textFieldName"
  [checkboxLlist]="items"
  valueFieldName="Id"
  (valueChange)="changed($event)"
  [group]="form"
  class="cheked">
</ssg-checkbox-list>
